export default "__VITE_ASSET__DQZ3JMwP__"